import React from "react";
import { Checkbox } from "@mui/material";

const CustomCheckbox = React.forwardRef((props, ref) => {
  return (
    <Checkbox
      ref={ref}
      sx={{
        "&:hover": {
          background: "transparent",
        },
        "&.MuiButtonBase-root": {
          color: "var(--gray-2)",
        },
        "&.MuiCheckbox-indeterminate": { color: "var(--primary)" },
        "&.Mui-checked": {
          color: "var(--primary)",
        },
        "& .MuiCheckbox-indeterminate": {
          color: "#1492AF",
        },
      }}
      {...props}
    />
  );
});

export default CustomCheckbox;
